// extracted by mini-css-extract-plugin
export const container = "OtherPartner-module--container--2nlJP";
export const partnerHeadline = "OtherPartner-module--partnerHeadline--17LXM";
export const headerDescContainer = "OtherPartner-module--headerDescContainer--378Et";
export const partnerList = "OtherPartner-module--partnerList--2b-k3";
export const partnerNote = "OtherPartner-module--partnerNote--3xjDd";
export const animationPartnerList = "OtherPartner-module--animation-partner-list--3Odzc";